import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ThemeContext } from 'styled-components';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

const CustomCheckBox = (props) => {
  const { ...other } = props;
  const themeContext = useContext(ThemeContext);
  const checkBoxStyles = ( ) => ({
    root: {
      '&$checked': {
        color: themeContext.checkboxes.color.primaryColor,
      },
      padding: '5px',
    },
    checked: {},
  });
  const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);
  return (
    <>
      <CustomCheckbox
        {...other} />
    </>
  );
};

CustomCheckBox.propTypes = {
  value: PropTypes.bool,
  handler: PropTypes.func,
};

export default CustomCheckBox;
